import { useTranslation } from 'react-i18next';

import { Button, Typography } from '@cfa/react-components';

// NOTE: important to minimize dependencies on this screen to reduce the chance
// of it blowing up after another screen has also blown up. Ideally no Redux
// connection. Some duplication is okay to keep this component simple.
const GenericError = () => {
  const { t } = useTranslation();
  // This is non-reactive, but this component cannot get to redux because
  // it is outside of the redux provider.

  const handleReload = () => window.location.reload();

  return (
    <>
      <main className="h-full text-center">
        <div className="mx-auto my-0 px-6 pt-12 pb-10 md:max-w-[684px] md:pt-28">
          <Typography color={'secondary'} variant={'h1'}>
            {t('GenericError.oops')}
          </Typography>
          <Typography className="mt-12">
            {t('GenericError.reloadThisPage')}
          </Typography>
          <Button color="secondary" onClick={handleReload}>
            {t('GenericError.reloadPage')}
          </Button>
        </div>
      </main>
    </>
  );
};

export default GenericError;
